import React from 'react'
import DayBadge from './DayBadge'
import DayTime from './DayTime'
import { ScheduleDayModel } from '../types/ScheduleTypes'

import {
  DAY_TYPE_BORDER_COLORS,
  DAY_TYPE_COLORS,
  DAY_TYPE_STRIPE_COLORS,
} from '../constants/DayColors'

const BORDER_RADIUS = 6

const DayItem = ({
  day,
  width,
  isFirstInGroup = true,
  isLastInGroup = true,
}: {
  day: ScheduleDayModel
  width: number
  isFirstInGroup?: boolean
  isLastInGroup?: boolean
}) => {
  const getColorBasedOnDayType = (day: ScheduleDayModel) => {
    return DAY_TYPE_COLORS[day.dayType] ?? '#E7ECF0'
  }

  const getCellColor = (day: ScheduleDayModel) => {
    if (day == null) return '#F8F9FB'
    return getColorBasedOnDayType(day)
  }

  const borderRadius = [
    isFirstInGroup ? BORDER_RADIUS : 0,
    isLastInGroup ? BORDER_RADIUS : 0,
    isLastInGroup ? BORDER_RADIUS : 0,
    isFirstInGroup ? BORDER_RADIUS : 0,
  ]
    .map((r) => `${r}px`)
    .join(' ')

  return (
    <div
      style={{
        width,
        borderRadius,
        background: getCellColor(day),
        borderLeftColor: DAY_TYPE_BORDER_COLORS[day?.dayType] ?? '#D9D9D9',
      }}
      className="tw-flex tw-flex-1 tw-select-none tw-flex-col tw-overflow-hidden tw-border-l-[1px]"
    >
      <DayBadge dayType={day?.dayType} />
      <div
        className="tw-h-[2px] tw-w-full"
        style={{
          backgroundColor: DAY_TYPE_STRIPE_COLORS[day?.dayType] ?? '#D9D9D9',
        }}
      />
      <DayTime
        showSchedule={day?.showSchedule}
        dayType={day?.dayType}
        dayStartTime={day?.dayStartTime}
        dayScheduleTime={day?.dayScheduleTime}
      />
    </div>
  )
}

export default DayItem
